import { LOCALE_ID, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import '@nha/extensions';
import { CanActivateGuard, NHA403Component, NHAAuthModule, bootstrapNhaApp } from '@nha/auth';
import { AttendanceComponent } from './app/attendance.component';
import { ATSharedModule } from './app/shared/attendance-shared.module';
import { LoggerApiModule } from '@nha/api/logger';
import { NHAFiltersModule, NHAApplicationContainerModule } from '@nha/components';
import { NHAStateModule } from '@nha/state/nha-state.module';
import { withEnabledBlockingInitialNavigation, provideRouter, TitleStrategy } from '@angular/router';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NHATagManagerModule } from '@nha/analytics/tag-manager.module';
import { NHAMonitoringModule } from '@nha/monitoring';
import { ATMStudentAttendanceService } from './app/api/services/attendance-management-student.service';
import { StudentSummaryService } from '@attendance/legacy-api/services/student-summary.service';
import { ScriptLoaderService } from '@nha/services';
import { AppSettingsInitializer } from '@nha/config/providers/app-settings-initializer.service';
import { MyNhaTitleStrategy } from '@nha/strategy/mynha-title.strategy';

bootstrapNhaApp(AttendanceComponent, {
	providers: [
		provideZoneChangeDetection(),
		importProvidersFrom(
			NHAMonitoringModule,
			NHATagManagerModule,
			// NHA
			NHAStateModule,
			NHAFiltersModule,
			NHAAuthModule.forRoot(),
			NHAApplicationContainerModule.forRoot(),
			LoggerApiModule.forRoot(),
			// Common Attendance
			ATSharedModule
		),
		{ provide: LOCALE_ID, useValue: 'en-US' },
		AppSettingsInitializer,
		ScriptLoaderService,
		{
			provide: TitleStrategy,
			useClass: MyNhaTitleStrategy
		},
		StudentSummaryService,
		ATMStudentAttendanceService,
		{ provide: 'AT_MANAGER_GRID_FILTERS_KEY', useValue: 'at-manager-grid-filters' },
		{ provide: 'ATM_TEACHER_VIEW_FILTERS_KEY', useValue: 'atm-teacher-view-filters' },
		provideAnimations(),
		provideHttpClient(withInterceptorsFromDi()),
		provideRouter(
			[
				{
					path: 'manager',
					loadChildren: () => import('./app/manager').then((m) => m.AttendanceManagerModule),
					canActivate: [CanActivateGuard],
					data: {
						routeGuardSettings: {
							entitlements: ['AttendanceManagement:Feature|Student View: View', 'AttendanceManagement:Feature|Teacher:View'],
							redirect: '/403'
						}
					},
					title: 'Attendance Manager'
				},
				{
					path: 'safety',
					loadChildren: () => import('./app/safety-attendance').then((m) => m.SafetyAttendanceModule),
					title: 'Safety Attendance'
				},
				{
					path: '403',
					component: NHA403Component
				}
			],
			withEnabledBlockingInitialNavigation()
		)
	]
});
